export const FILTERS = [
  {
    key: 'all',
    value: 'All'
  },
  {
    key: 'landings',
    value: 'Landings',
  },
  {
    key: 'selfcare',
    value: 'Selfcare',
  }
];

export const FILTERKEYS = {
  'landings' : 'Landings',
  'selfcare' : 'Selfcare',
};


// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/constants/index.js